<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <ul v-if="items">
    <template v-for="(item, i) of items" :key="item.label || i">
      <li
        v-if="visible(item) && !item.separator"
        :key="item.label || i"
        :class="[
          {
            'layout-menuitem-category': root,
            'active-menuitem': activeIndex === i && !item.to && !item.disabled,
          },
        ]"
        role="none"
      >
        <template v-if="root">
          <router-link
            v-if="
              item.to?.name === 'navigation' ||
              item.to?.name === 'navigation-dossier'
            "
            :to="item.to"
            :class="['layout-menuitem-root-text', 'p-ripple']"
            :aria-label="item.label"
            exact
            role="menuitem"
            v-ripple
          >
            {{ item.label }}
          </router-link>
          <router-link
            v-else-if="item.to"
            :to="item.to"
            :class="['layout-menuitem-root-text', 'p-ripple']"
            :aria-label="item.label"
            exact
            role="menuitem"
            v-ripple
          >
            {{ item.label }}
          </router-link>
          <a
            v-else
            :href="item.url || '#'"
            :class="['layout-menuitem-root-text', 'p-ripple']"
            :aria-label="item.label"
            role="menuitem"
            v-ripple
          >
            {{ item.label }}
          </a>
          <AppSubmenu
            v-if="visible(item)"
            :items="item.items"
            @menuitem-click="$emit('menuitem-click', $event)"
          />
        </template>
        <template v-else>
          <router-link
            v-if="
              item.to?.name === 'navigation' ||
              item.to?.name === 'navigation-dossier'
            "
            :to="item.to"
            :class="['p-ripple']"
            :aria-label="item.label"
            exact
            role="menuitem"
            v-ripple
          >
            <i :class="item.icon" />
            <span>{{ item.label }}</span>
          </router-link>
          <router-link
            v-else-if="item.to"
            :to="item.to"
            :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
            :style="item.style"
            :target="item.target"
            :aria-label="item.label"
            exact
            role="menuitem"
            v-ripple
          >
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </router-link>
          <a
            v-else
            :href="item.url || '#'"
            :style="item.style"
            :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
            :target="item.target"
            :aria-label="item.label"
            role="menuitem"
            v-ripple
          >
            <i :class="item.icon" />
            <span>{{ item.label }}</span>
          </a>
          <i
            v-if="item.items"
            @click="onMenuItemClick($event, item, i)"
            class="pi pi-fw pi-angle-down menuitem-toggle-icon"
          />
          <transition name="layout-submenu-wrapper">
            <AppSubmenu
              v-if="visible(item)"
              v-show="activeIndex === i"
              :items="item.items"
              @menuitem-click="$emit('menuitem-click', $event)"
            />
          </transition>
        </template>
      </li>
      <li
        class="p-menu-separator"
        :style="item.style"
        v-if="visible(item) && item.separator"
        :key="'separator' + i"
        role="separator"
      />
    </template>
  </ul>
</template>
<script>
export default {
  name: "AppSubmenu",
  props: {
    items: Array,
    root: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: null,
    };
  },
  methods: {
    onMenuItemClick(event, item, index) {
      if (item.disabled) {
        event.preventDefault();
        return;
      }

      if (!item.to && !item.url) {
        event.preventDefault();
      }

      //execute command
      if (item.command) {
        item.command({ originalEvent: event, item: item });
      }

      this.activeIndex = index === this.activeIndex ? null : index;

      this.$emit("menuitem-click", {
        originalEvent: event,
        item: item,
      });
    },
    visible(item) {
      return typeof item.visible === "function"
        ? item.visible()
        : item.visible !== false;
    },
  },
};
</script>
